__turbopack_context__.v({
  "className": "montserrat_f3c91b77-module__0F6t2q__className",
  "variable": "montserrat_f3c91b77-module__0F6t2q__variable",
});
